import { withAppContext } from 'Services/Context'

import Sidebar from './Sidebar'

export default withAppContext(Sidebar)
